import {
    getSearch,
} from "../api"
import {
    RESET_STATE,
    SET_LOADING,
    SET_LIST,
    RESET_SEARCH_PARAMS,
} from "../constant-types"
import {
    defaultSetListMutation,
    defaultSetLoading,
    defaultUpdateInListMutation,
    defaultAddInListMutation,
    defaultRemoveInListMutation
} from "../default-method"
import {
    getField,
    updateField
} from 'vuex-map-fields'

const getDefaultState = () => {
    return {
        list: { data: [] },
        search_params: getDefaultSearchParamsState()
    }
}

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text: '',
        loading: false,
        filter_sort: [{
            column: 'created_at',
            sort: 'desc',
            icon: ['fas', 'angle-down']
        }],
        filter_page: 1,
        filter_limit: 20,
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetListMutation,
        ...defaultSetLoading,
        ...defaultAddInListMutation,
        ...defaultUpdateInListMutation,
        ...defaultRemoveInListMutation,
        [RESET_SEARCH_PARAMS](state) {
            state.search_params = getDefaultSearchParamsState();
        },
        updateField

    },
    // can async
    actions: {
        loadList({
            commit,
            state,
            getters
        }, payload = {
            resetPage: false
        }) {
            if (payload.resetPage) {
                commit('updateField', {
                    path: 'search_params.filter_page',
                    value: 1
                })
            }
            commit(SET_LOADING, true)
            return getSearch({
                    words: _.split(state.search_params.filter_search_text, ' '),
                    fields: ['warehouse>name', 'auditBy>name']
                },
                [],
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                ['stockAuditItems.product', 'warehouse:id,name','auditBy:id,name'],
                [],
                'stock-audit',
                (response) => commit(SET_LIST, response),
                () => {},
                () => {
                    commit(SET_LOADING, false)
                }
            )
        },
    },
    // call variable with custom display
    getters: {
        getField
    },
})
